// Single source of truth for which access tier can see which web page.
// Read by both RequireAuth (route guard) and Sidebar (nav filtering) — never
// duplicate this mapping elsewhere.
//
// Each tier is a strict superset of the one below it. Rules are checked
// longest-path-first (exact match, or "starts with path + '/'"), so a specific
// path like /team/add is matched before the general /team prefix rule.
const RULES = [
  // Overview
  { path: '/dashboard', tiers: ['Incident Commander', 'Admin'] },
  { path: '/command', tiers: ['Incident Commander', 'Admin'] },
  { path: '/executive', tiers: ['Incident Commander', 'Admin'] },
  { path: '/team-leader', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },

  // Operations
  { path: '/activation/announce', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/activation/simulate', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/activation/drills', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/activation', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/active-incident', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/closed-incident', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/team/add', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/team/members', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/team', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/hospitals', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/staff-app', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/patient-app', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/patient', tiers: ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'] },
  { path: '/stakeholders', tiers: ['Incident Commander', 'Admin'] },
  { path: '/inventory', tiers: ['Team Leader', 'Incident Commander', 'Admin'] },

  // System — admin-only
  { path: '/reports', tiers: ['Incident Commander', 'Admin'] },
  { path: '/users', tiers: ['Admin'] },
  { path: '/audit', tiers: ['Admin'] },
  { path: '/integrations', tiers: ['Admin'] },
  { path: '/governance', tiers: ['Admin'] },
  { path: '/settings', tiers: ['Admin'] },
].sort((a, b) => b.path.length - a.path.length);

// A tier missing entirely (stale localStorage from before this feature shipped, or an
// unrecognized/new path) is treated as allowed — fail open rather than break navigation.
export function isPathAllowed(pathname, tier) {
  if (!tier) return true;
  const rule = RULES.find((r) => pathname === r.path || pathname.startsWith(r.path + '/'));
  if (!rule) return true;
  return rule.tiers.includes(tier);
}

// Where to send a tier when it hits a page it can't see.
export const TIER_HOME = {
  'Medical Staff': '/activation',
  'Team Leader': '/team-leader',
  'Incident Commander': '/dashboard',
  Admin: '/dashboard',
};

export const ALL_TIERS = ['Medical Staff', 'Team Leader', 'Incident Commander', 'Admin'];
